<template>
  <v-row v-if="events.length" class="ma-0" no-gutters>
    <v-col>
      <slot name="title">
        <h2 class="text-break homepageTitle mb-1">
          {{ title }}
        </h2>
      </slot>

      <ItemGroup
        :items="events"
        itemImgSrc="PictureUrl"
        itemText="Name"
        @select="onEventClick"
      />
    </v-col>
  </v-row>
</template>

<script>
import trendingEventsMixin from '@/mixins/trendingEvents';
import ItemGroup from '@/components/generalComponents/uiComponents/ItemGroup';

export default {
  name: 'TrendingEvents',
  mixins: [trendingEventsMixin],
  components: {
    ItemGroup,
  },
};
</script>
